import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';
import LoadingAnimation from '../../components/common/LoadingAnimation/LoadingAnimation';
import { useAuth } from '../../contexts/AuthContext';
import { parseApiError } from '../../utils/parseErrorMessage';

export default function LoginPage() {
  const navigate = useNavigate();
  const { login, isLoading: authLoading, isAuthenticated } = useAuth();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [usernameError, setUsernameError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Redirect if already authenticated
  React.useEffect(() => {
    if (isAuthenticated && !authLoading) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, authLoading, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setUsernameError('');
    setPasswordError('');
    setIsLoading(true);

    try {
      await login({ username, password });
      // Navigation is handled by AuthContext after successful login
    } catch (error) {
      const errorMessage = parseApiError(error)
      setUsernameError(errorMessage);
      setPasswordError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const isLoadingState = isLoading || authLoading;

  return (
    <div className="login-page">
      {isLoadingState && <LoadingAnimation />}
      <div className="login-container">
        <div className="login-branding">
          <h1 className="login-title">Smart Plan</h1>
          <p className="login-subtitle">Лучшие прогнозы = лучшие продажи</p>
        </div>

        <div className="login-form-container">
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="username" className="form-label">
                Логин:
              </label>
              <input
                type="text"
                id="username"
                className={`form-input ${usernameError ? 'error' : ''}`}
                value={username}
                onChange={(e) => {
                  setUsername(e.target.value);
                  if (usernameError) setUsernameError('');
                }}
                placeholder="Введите логин"
                disabled={isLoadingState}
                autoComplete="username"
              />
              {usernameError && <div className="form-error">{usernameError}</div>}
            </div>

            <div className="form-group">
              <label htmlFor="password" className="form-label">
                Пароль:
              </label>
              <input
                type="password"
                id="password"
                className={`form-input ${passwordError ? 'error' : ''}`}
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (passwordError) setPasswordError('');
                }}
                placeholder="Введите пароль"
                disabled={isLoadingState}
                autoComplete="current-password"
              />
              {passwordError && <div className="form-error">{passwordError}</div>}
            </div>

            <button
              type="submit"
              style={{ marginTop: 12, fontSize: 20, height:62 }}
              className="primary-button"
              disabled={isLoadingState}
            >
              Войти
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
